import { request } from '@/shared/api/request'

export const getTradeUnionSignedXml = (externalId, isEmployee) => {
	return request({ url: `colcontract/ecd/tradeUnion/xml/${externalId}?isEmployee=${isEmployee}`, method: 'GET' })
}
